import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { ADMIN_URL } from './constant/BaseApiUrl';

export default class GroupTypeService {
  getGroupTypeList() {
    return axios.get(`${ADMIN_URL}${ApiKey.GROUP_TYPE}`);
  }
  getGroupTypeManagementList() {
    return axios.get(`${ADMIN_URL}${ApiKey.GROUP_TYPE}/list-management`);
  }
  getGroupTypeDetail(id) {
    return axios.get(`${ADMIN_URL}${ApiKey.GROUP_TYPE}/${id}`);
  }
  addGroupType(payload) {
    return axios.post(`${ADMIN_URL}${ApiKey.GROUP_TYPE}`, payload);
  }
  deleteGroupType(id) {
    return axios.delete(`${ADMIN_URL}${ApiKey.GROUP_TYPE}/${id}`);
  }
  updateStatus(id, status) {
    return axios.put(`${ADMIN_URL}${ApiKey.GROUP_TYPE}/${id}/status?status=${status}`);
  }
  updateStatusInstaQuote(id, instaQuote) {
    return axios.put(`${ADMIN_URL}${ApiKey.GROUP_TYPE}/${id}/insta-quote?status=${instaQuote}`);
  }
}
